import React from 'react'

export const Avatar = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g opacity='0.79746'>
      <path
        d='M8.00878 2C6.13045 2 5.30868 3.596 5.30868 5.216C5.30868 7.34 6.55307 8.3 6.55307 9.008C6.55307 9.284 6.36524 9.632 5.8487 9.908L3.10165 11.396C2.13901 11.936 2.62033 14 2.62033 14H13.3855C13.3855 14 13.8551 11.936 12.8924 11.396L10.1454 9.896C9.64057 9.62 9.40578 9.32 9.40578 9.044C9.40578 8.396 10.6737 7.472 10.6737 5.192C10.6854 3.296 9.69927 2 8.00878 2Z'
        stroke='#878787'
        strokeWidth='1.2'
      />
    </g>
  </svg>
)

export default Avatar
